import images from "./images/images";
import icons from "./icons/icons";

const assets = {
  images,
  icons,
};

export default assets;
